import { notesRailDemoRegularNotesA } from './notesRailDemoRegularNotesA.seed'
import { notesRailDemoRegularNotesB } from './notesRailDemoRegularNotesB.seed'

/** @type {import('../lib/types.js').NotesRailNoteWire[]} */
export const notesRailDemoRegularNotes = [...notesRailDemoRegularNotesA, ...notesRailDemoRegularNotesB]
